import v from '@/lib/validator';

const LoginCustomSchema = (translate: any) => {
  const loginValidations = v.methods().min({length: 4, message: translate('login.authErrors.user.minChar')}).max({length: 24, message: translate('login.authErrors.user.maxChar')})
  const passwordValidations = v.methods().min({length: 6, message: translate('login.authErrors.password.minChar')}).max({length: 24, message: translate('login.authErrors.password.maxChar')}).regex({pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/, message: translate('login.authErrors.password.regex')})

  const Schema = v.object({
    login: loginValidations,
    senha: passwordValidations
  })

  return Schema
}

export default LoginCustomSchema